import { AppThunkAction } from "..";
import { KnownAction, RECEIVE_ALERT_DATA, SHOW_LOADER } from "./types";
import * as httpClient from "../../util/httpClient";
import { debug } from "console";
export const actionCreators = {
    getAlertData:
        (isBusinessUser: boolean, reload: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();
            if (state.alertState && state.alertState.alertData && !reload) {
                return;
            }

            dispatch({ type: SHOW_LOADER, isAlertLoading: true });
            const requestBody = {
                statusList: null,
                categoryList: ["NONCREDIT", "CREDIT", "TRANSMONITOR", "BIZCREDIT"],
                forActiveServicesOnly: false,
            };

            httpClient
                .sendRequest("post", "api/alerts/getAlertsForConsolidatedUser", requestBody)
                .then((data) => {
                    let alertList: any;
                    if (isBusinessUser) {
                        alertList = data.filter((alert: any) => ["BIZCRDRPRT", "BIZCRDRPT_DB"].indexOf(alert.serviceType) < 0);
                    } else {
                        alertList = data;
                    }
                   // Sort by created date in descending order.            
                    alertList.sort((a:any, b:any) => {
                        const aDate = new Date(a["createdDate"]);
                        const bDate = new Date(b["createdDate"]);
                        return bDate.getTime() - aDate.getTime();
                    });

                    //alertList.sort((a: any, b: any) => (b["createdDate"] > a["createdDate"] ? 1 : a["createdDate"] > b["createdDate"] ? -1 : 0));
                    dispatch({ type: RECEIVE_ALERT_DATA, alertData: alertList });
                    dispatch({ type: SHOW_LOADER, isAlertLoading: false });
                })
                .catch(function (error) {
                    const temp = error;
                    dispatch({ type: SHOW_LOADER, isAlertLoading: false });
                });
        },

    updateAlertsStatus:
        (alertData: any, status: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();
            const stateAlertData: any = state.alertState ? state.alertState?.alertData : [];
            if (stateAlertData.length > 0) {
                const updatedData = stateAlertData.map((alert: any) => {
                    if (alert.alertID === alertData.alertItemRequest[0].alertId) {
                        alert["alertStatus"] = status;
                        return alert;
                    } else {
                        return alert;
                    }
                });
                dispatch({ type: RECEIVE_ALERT_DATA, alertData: updatedData });
            }
        },
};
